export class PasswordChangedController {

    private count: number = 5;
    private IsAuthenticatedId: string = "#IsAuthenticated";
    private RedirectUrlId: string = "#ReturnUrl";
    private RedirectTimerId: string = "#countDownTimer";

    constructor() {
        const self = this;

        $(window).bind("load", () => {
            if ($(self.RedirectTimerId).length > 0) {
                self.countDown();
            }
        });

        $(document).ready(() => {
            $("a.RedirectUri").on("click", () => self.redirect($(self.IsAuthenticatedId).val()));   
        });
    }

    countDown(): void {
        const self = this;

        const redirectTimer = $(self.RedirectTimerId);
        let timeout = 0;

        if (redirectTimer) {
            if (self.count > 0) {
                redirectTimer.html(self.count.toString());
                self.count--;
                timeout = window.setTimeout(() => {
                    self.countDown();
                }, 1000);
            } else {
                clearTimeout(timeout);
                self.count = 5;
                self.redirect($(self.IsAuthenticatedId).val());
            }
        }
    }

    redirect(isAuthenticated: any): void {
        var self = this;
        var redirectUrl = <string>$(self.RedirectUrlId).val();

        if ((isAuthenticated === true || isAuthenticated === "True")
                && redirectUrl !== undefined && redirectUrl !== null) {
            window.location.replace(redirectUrl);
        } else {
            (<any>document.forms[0]).submit();
        }
    }
}